const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Crypto {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'cryptoExt', name: '🔐 暗号化', color1: '#795548', color2: '#6D4C41',
            blocks: [
                { opcode: 'base64Enc', blockType: BlockType.REPORTER, text: '[T] をBase64エンコード', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello' } } },
                { opcode: 'base64Dec', blockType: BlockType.REPORTER, text: '[T] をBase64デコード', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'SGVsbG8=' } } },
                { opcode: 'urlEnc', blockType: BlockType.REPORTER, text: '[T] をURLエンコード', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello World' } } },
                { opcode: 'urlDec', blockType: BlockType.REPORTER, text: '[T] をURLデコード', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello%20World' } } },
                { opcode: 'hash', blockType: BlockType.REPORTER, text: '[T] のハッシュ', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello' } } }
            ]
        };
    }
    base64Enc(args) { try { return btoa(unescape(encodeURIComponent(Cast.toString(args.T)))); } catch(e) { return ''; } }
    base64Dec(args) { try { return decodeURIComponent(escape(atob(Cast.toString(args.T)))); } catch(e) { return ''; } }
    urlEnc(args) { return encodeURIComponent(Cast.toString(args.T)); }
    urlDec(args) { try { return decodeURIComponent(Cast.toString(args.T)); } catch(e) { return ''; } }
    hash(args) { var s = Cast.toString(args.T), h = 0; for (var i = 0; i < s.length; i++) { h = ((h << 5) - h) + s.charCodeAt(i); h |= 0; } return Math.abs(h).toString(16); }
}
module.exports = Scratch3Crypto;